import { createStore, combineReducers } from 'redux';
import cartReducer from './reducers/cartReducer';
import wishlistReducer from './reducers/wishlistReducer';

// Load initial state from localStorage
const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

// Save state to localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);
  } catch (err) {
    // Handle errors here
  }
};

const rootReducer = combineReducers({
  cart: cartReducer,
  wishlist: wishlistReducer,
});

const persistedState = loadState();
const store = createStore(rootReducer, persistedState);

// Subscribe to store changes to save state
store.subscribe(() => {
  saveState(store.getState());
});

export default store; 